import axiosInstance from '../api/axios';
import type { GetUsersParams } from '@/types/auth';

const DEFAULT_LIST_LIMIT = 1000;

export const usersService = {
  getUsers: async (params: GetUsersParams = {}) => {
    const response = await axiosInstance.get('/users', {
      params: {
        limit: DEFAULT_LIST_LIMIT,
        ...params,
      },
    });
    return response.data;
  },

  getUser: async (id: string) => {
    const response = await axiosInstance.get(`/users/${id}`);
    return response.data;
  },

  updateUser: async (id: string, data: any) => {
    const response = await axiosInstance.put(`/users/${id}`, data);
    return response.data;
  },

  deleteUser: async (id: string) => {
    const response = await axiosInstance.delete(`/users/${id}`);
    return response.data;
  },

  changePassword: async (id: string, data: { new_password: string; confirm_password: string }) => {
    const response = await axiosInstance.post(`/users/${id}/change-password`, data);
    return response.data;
  },

  toggleUserActive: async (id: string) => {
    const response = await axiosInstance.patch(`/users/${id}/toggle-active`);
    return response.data;
  },

  resetUser2fa: async (id: string) => {
    const response = await axiosInstance.delete(`/users/${id}/2fa`);
    return response.data;
  },
}; 
